<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Scholarship Details</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Admission</a></span>
                                        </div>
                                        <span>Scholarship Details</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- program routine area start here  -->
      <!-- Page Heading -->
    <section class="scholarship-header">
      <div class="scholarship-title-row">
        <span class="scholarship-leaf">❧</span>
        <h1>Scholarship &amp; Fee Concession</h1>
        <span class="scholarship-leaf reverse">❧</span>
      </div>

      <div class="session-heading">
        <span class="heading-line"></span>
        <div class="session-badge">
          Regular Course • Academic Session 2026–27
        </div>
        <span class="heading-line"></span>
      </div>
    </section>

    <!-- Regular Course -->
    <section class="scholarship-table-card">

      <div class="course-label">
        <span>Regular Course</span>
      </div>

      <div class="table-responsive">
        <table class="scholarship-table regular-table">

          <thead>
            <tr>
              <th rowspan="2">Category</th>
              <th rowspan="2">Scholarship % for<br>2026–27</th>
              <th colspan="2">Actual for 2025–26</th>
              <th colspan="2">Projected for 2026–27</th>
            </tr>

            <tr>
              <th>No. of<br>Students</th>
              <th>Scholarship<br>Amount</th>
              <th>No. of<br>Students</th>
              <th>Scholarship<br>Amount</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in regularScholarships" :key="item.category">
              <td>{{ item.category }}</td>
              <td>{{ item.percentage }}</td>
              <td>{{ item.actualStudents }}</td>
              <td>{{ item.actualAmount }}</td>
              <td>{{ item.projectedStudents }}</td>
              <td>{{ item.projectedAmount }}</td>
            </tr>

            <tr class="total-row">
              <td colspan="2">Total</td>
              <td>189</td>
              <td>1135275</td>
              <td>194</td>
              <td>1100000</td>
            </tr>
          </tbody>

        </table>
      </div>

    </section>

    <!-- Foundation Course -->
    <section class="foundation-section">

      <div class="foundation-heading">
        <span></span>
        <h2>Foundation Course</h2>
        <span></span>
      </div>

      <div class="scholarship-table-card foundation-card">

        <div class="table-responsive">
          <table class="scholarship-table foundation-table">

            <thead>
              <tr>
                <th rowspan="2">Concession Type</th>
                <th rowspan="2">Concession</th>
                <th colspan="2">Actual for 2025–26</th>
                <th colspan="2">Projected for 2026–27</th>
              </tr>

              <tr>
                <th>Students</th>
                <th>Amount</th>
                <th>Students</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in foundationConcessions" :key="item.type">
                <td>{{ item.type }}</td>
                <td>{{ item.concession }}</td>
                <td>{{ item.actualStudents }}</td>
                <td>{{ item.actualAmount }}</td>
                <td>{{ item.projectedStudents }}</td>
                <td>{{ item.projectedAmount }}</td>
              </tr>

              <tr class="total-row">
                <td colspan="2">Total</td>
                <td>12</td>
                <td>183000</td>
                <td>16</td>
                <td>200000</td>
              </tr>
            </tbody>

          </table>
        </div>

      </div>
    </section>

    <!-- Approval Notice -->
    <section class="scholarship-notice">
      <span class="notice-icon">ⓘ</span>
      <p>
        Any deviation or change in scholarship must be approved through
        a special approval process on a case-to-case basis.
      </p>
    </section>

    <!-- Foundation Scholarship Note -->
    <section class="foundation-note">

      <div class="note-icon">
        <svg viewBox="0 0 64 64" aria-hidden="true">
          <path
            d="M2 22L32 8L62 22L32 36L2 22Z"
            fill="currentColor"
          />
          <path
            d="M14 29V42C14 42 22 51 32 51C42 51 50 42 50 42V29L32 38L14 29Z"
            fill="currentColor"
          />
          <path
            d="M60 24V43"
            stroke="currentColor"
            stroke-width="3"
          />
          <circle cx="60" cy="46" r="3" fill="currentColor"/>
        </svg>
      </div>

      <div class="note-divider"></div>

      <p>
        With the increase in number of students in session 2026–27,
        the scholarship amount of Rs. 2.00 lakhs under the head
        foundation courses is likely to be inadequate keeping in view
        scholarships being provided by our competitors to foundation students.
      </p>

    </section>


    </main>
</template>

<script>
export default {
  name: "ScholarshipView",

  data() {
    return {
      regularScholarships: [
        {
          category: "BPL (Below Poverty Level)",
          percentage: "—",
          actualStudents: "21",
          actualAmount: "37025",
          projectedStudents: "23",
          projectedAmount: "40000",
        },
        {
          category: "Merit Students - Marks 75% to 85%",
          percentage: "35%",
          actualStudents: "—",
          actualAmount: "—",
          projectedStudents: "1",
          projectedAmount: "5000",
        },
        {
          category: "Merit Students - Marks 85% to 90%",
          percentage: "25%",
          actualStudents: "3",
          actualAmount: "7500",
          projectedStudents: "4",
          projectedAmount: "10000",
        },
        {
          category: "Merit Students - Marks 90% to 100%",
          percentage: "35%",
          actualStudents: "8",
          actualAmount: "64500",
          projectedStudents: "9",
          projectedAmount: "70000",
        },
        {
          category: "Orphan Student",
          percentage: "75%",
          actualStudents: "—",
          actualAmount: "—",
          projectedStudents: "1",
          projectedAmount: "7500",
        },
        {
          category: "Single parent - Students",
          percentage: "75%",
          actualStudents: "31",
          actualAmount: "149150",
          projectedStudents: "32",
          projectedAmount: "152000",
        },
        {
          category: "National Sports Player",
          percentage: "50%",
          actualStudents: "—",
          actualAmount: "—",
          projectedStudents: "1",
          projectedAmount: "7500",
        },
        {
          category: "State Sports Player",
          percentage: "75%",
          actualStudents: "1",
          actualAmount: "8500",
          projectedStudents: "1",
          projectedAmount: "10000",
        },
        {
          category: "Scholarship (Defense - Martyr)-Rebate 75%",
          percentage: "50%",
          actualStudents: "—",
          actualAmount: "—",
          projectedStudents: "1",
          projectedAmount: "10000",
        },
        {
          category: "Scholarship (Defense-Service)-Rebate 50%",
          percentage: "75%",
          actualStudents: "1",
          actualAmount: "7500",
          projectedStudents: "1",
          projectedAmount: "8000",
        },
        {
          category: "Staff Students",
          percentage: "50%",
          actualStudents: "55",
          actualAmount: "396400",
          projectedStudents: "55",
          projectedAmount: "380000",
        },
        {
          category: "Management Discretion",
          percentage: "75%",
          actualStudents: "69",
          actualAmount: "464700",
          projectedStudents: "65",
          projectedAmount: "400000",
        },
      ],

      foundationConcessions: [
        {
          type: "Concession in Foundation Fee Management rebate",
          concession: "25% to 100%",
          actualStudents: "8",
          actualAmount: "163000",
          projectedStudents: "10",
          projectedAmount: "170000",
        },
        {
          type: "Concession in Foundation Fee Management Rebate ₹5000/-",
          concession: "₹5000/-",
          actualStudents: "4",
          actualAmount: "20000",
          projectedStudents: "6",
          projectedAmount: "30000",
        },
      ],
    };
  },
};
</script>

